import { render } from "./ModeratorsList.vue?vue&type=template&id=c310d814&scoped=true"
import script from "./ModeratorsList.vue?vue&type=script&lang=js"
export * from "./ModeratorsList.vue?vue&type=script&lang=js"

import "./ModeratorsList.vue?vue&type=style&index=0&id=c310d814&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c310d814"]])

export default __exports__